import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { fetchAttributionByChain } from 'src/utils/fetchAttributionByChain';
import { TBlockchain } from 'src/types';

export function useBatchAttributions(chain: TBlockchain) {
  const qc = useQueryClient();

  return useCallback(
    async (addrs: string[]) => {
      addrs.forEach((addr) => {
        const data = qc.getQueryData(['attribution', chain, addr]);
        console.log(`[LOG] Address: ${addr}, Cached Data:`, data);
      });

      const missing = addrs.filter(
        (addr) => qc.getQueryData(['attribution', chain, addr]) === undefined,
      );
      if (missing.length === 0) return;

      const map = await fetchAttributionByChain(chain, missing);

      missing.forEach((addr) => {
        const value = map[addr];
        if (value !== undefined) {
          // a "real" attribution object (or `null` if you want to mark "checked but empty")
          qc.setQueryData(['attribution', chain, addr], value);
        } else {
          // optional: if you want to remember "we already looked and got nothing,"
          // cache a null sentinel so ===undefined is false next time
          qc.setQueryData(['attribution', chain, addr], null);
        }
      });

      // Invalidate attribution quota since we just consumed some quota
      // Only invalidate if we actually fetched attributions (not empty result)
      if (Object.keys(map).length > 0) {
        void qc.invalidateQueries({
          queryKey: ['attributionQuota'],
        });
      }
    },
    [chain, qc],
  );
}
